import { useState, useEffect, useContext, useRef } from "react";
import DataTable from "react-data-table-component";

import HeaderDashboard from "../../Components/HeaderDashboard";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Routes/AuthProvider";
import { InsuranceTransactionReport } from "../../Services/ReservationsApi";

const AllTransactions = () => {
    const { name, userName, roles } = useContext(AuthContext);
    const userRole = roles?.[0];

    const isTmcAdmin = roles?.includes("TMC Operations");
    const isCorpTravel = roles?.includes("Corporate Traveller");
    const navigate = useNavigate();
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        bookingRefNo: "",
        bookingStatus: "",
    });

    const tableWrapperRef = useRef(null);
    const [visibleColumns, setVisibleColumns] = useState([]);
    const [hiddenColumns, setHiddenColumns] = useState([]);

    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    // Convert "dd/mm/yy" or "dd/mm/yyyy" → Date object
    const convertToDate = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    useEffect(() => {
        $("#fromDate").datepicker({
            dateFormat: "dd/mm/yy",
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    fromDate: dateText,
                }));
            },
        });
    }, []);

    useEffect(() => {
        $("#toDate").datepicker({
            dateFormat: "dd/mm/yy",
            maxDate: 0,
            onSelect: function (dateText) {
                setFilters((prev) => ({
                    ...prev,
                    toDate: dateText,
                }));
            },
        });
    }, []);

    // UPDATE minDate of ToDate WHEN fromDate changes
    useEffect(() => {
        if (filters.fromDate) {
            const minD = convertToDate(filters.fromDate);
            $("#toDate").datepicker("option", "minDate", minD);
        }
        handleSearch();
    }, [filters.fromDate]);

    const handleSearch = async () => {
        setLoading(true);
        try {
            const requestBody = {
                FromDate: filters.fromDate,
                ToDate: filters.toDate,
                ReferenceNo: filters.bookingRefNo,
                BookingStatus: filters.bookingStatus,
                UserName: userName,
            };
            console.log("requestBody:", requestBody);
            const data = await InsuranceTransactionReport(requestBody);

            // Handle the actual response structure: allTransactions.transactions
            const list = data?.allTransactions?.transactions || [];
            setTransactions(list);
            console.log("setTransactions", list);
        } catch (error) {
            console.error("Error fetching data:", error);
            alert(error.message);
        } finally {
            setLoading(false);
        }
    };

    const [filterText, setFilterText] = useState("");

    const filteredItems = transactions?.filter(
        (item) =>
            item.referenceNo?.toLowerCase().includes(filterText.toLowerCase()) ||
            item.corporateName?.toLowerCase().includes(filterText.toLowerCase()) ||
            item.policyNumber?.toLowerCase().includes(filterText.toLowerCase()) ||
            item.insuranceName?.toLowerCase().includes(filterText.toLowerCase()) ||
            item.corporateCode?.toLowerCase().includes(filterText.toLowerCase())
    ) || [];

    const customStyles = {
        table: {
            style: {
                backgroundColor: "#fff",
                borderRadius: "0px",
                overflow: "hidden",
            },
        },
        headRow: {
            style: {
                background: "#110942",
                minHeight: "55px",
                borderBottomWidth: "0",
            },
        },
        headCells: {
            style: {
                color: "#fff",
                fontSize: "14px",
                fontWeight: "600",
                textTransform: "uppercase",
            },
        },
        rows: {
            style: {
                minHeight: "60px",
                fontSize: "14px",
                borderBottom: "1px solid #eef2f7",
                '&:hover': {
                    backgroundColor: "#f4f8ff",
                    cursor: "pointer",
                },
            },
        },
        pagination: {
            style: {
                borderTop: "1px solid #eef2f7",
                minHeight: "60px",
            },
        },
    };

    const StatusBadge = ({ status }) => {
        let bg = "#ffe5e5";
        let color = "#ff1f1f";

        if (
            status === "Success" ||
            status === "Confirmed"
        ) {
            bg = "#e7f8ec";
            color = "#00a63e";
        }

        if (status === "Hold" || status === "Pending" || status === "BookingInitiated") {
            bg = "#fff3d6";
            color = "#ff9800";
        }

        if (status === "Failed" || status === "Cancelled") {
            bg = "#ffe5e5";
            color = "#ff1f1f";
        }

        return (
            <span
                style={{
                    background: bg,
                    color: color,
                    padding: "6px 10px",
                    borderRadius: "30px",
                    fontSize: "13px",
                    fontWeight: 600,
                    display: "inline-block",
                    minWidth: "95px",
                    textAlign: "center",
                }}
            >
                {status || "N/A"}
            </span>
        );
    };

    const allColumns = [
        {
            id: "referenceNo",
            name: "Ref No.",
            selector: row => row.referenceNo,
            sortable: true,
            cell: row => (
                <span
                    title="Details"
                    style={{
                        color: "#0d47a1",
                        fontWeight: "600",
                        cursor: "pointer"
                    }}
                    onClick={() =>
                        navigate(
                            `/reservations/insurance/TransactionsDetails?ReferenceNo=${row.referenceNo}&clientCode=${row.clientCode}&key=${row.key}`
                        )
                    }
                >
                    {row.referenceNo}
                </span>
            )
        },

        ...(!isCorpTravel ? [
            {
                id: "organization",
                name: "Entity Name",
                selector: row => row.corporateName,
                sortable: true,
                grow: 2,
                cell: row => (
                    <>
                        {row.corporateName} ({row.corporateCode})
                    </>
                ),
                priority: 2,
            },
            {
                id: "paxName",
                name: "Pax Name",
                selector: row => row.passengerNames,
                sortable: true,
                grow: 2,
                cell: row => (
                    <>
                        {row.passengerNames}
                    </>
                ),
                priority: 3,
            }
        ] : []),

        {
            id: "bookingDate",
            name: "Booking Date",
            selector: row => row.createdOn,
            sortable: true,
            priority: 4,
            grow: 2,
            cell: row => (
                <>
                    {row.createdOn || "-"}
                </>
            )
        },

        {
            id: "destination",
            name: "Destination",
            selector: row => row.destination,
            sortable: true,
            grow: 2,
            cell: row => (
                <>
                    {row.destination || "-"}
                </>
            )
        },

        {
            id: "policyNo",
            name: "Policy No.",
            selector: row => row.policyNumber,
            sortable: true,
            grow: 2,
            cell: row => (
                <>
                    {row.policyNumber || "-"}
                </>
            )
        },

        {
            id: "startDate",
            name: "Start Date",
            selector: row => row.startDate,
            sortable: true,
            cell: row => {
                if (!row.startDate) return "-";
                return row.startDate;
            }
        },

        {
            id: "endDate",
            name: "End Date",
            selector: row => row.endDate,
            sortable: true,
            cell: row => {
                if (!row.endDate) return "-";
                return row.endDate;
            }
        },

        {
            id: "paymentStatus",
            name: "Payment",
            selector: row => row.paymentStatus,
            sortable: true,
             cell: row => (
                <StatusBadge status={row.paymentStatus} />
            ),
            // cell: row => {
            //     let status = row.paymentStatus;
            //     if (!status) {
            //         status = row.paymentStatus ? "Completed" : "Pending";
            //     }
            //     return <StatusBadge status={status} />;
            // },
            cell: row => (
                <StatusBadge status={row.paymentStatus} />
            ),
            priority: 9,
        },

        {
            id: "bookingStatus",
            name: "Policy",
            selector: row => row.bookingStatus,
            sortable: true,
            cell: row => (
                <StatusBadge status={row.bookingStatus} />
            ),
            priority: 10,
        },

        {
            id: "amount",
            name: "Amount",
            selector: row => row.totalPremium || row.totalAmount,
            sortable: true,
            grow: 2,
            cell: row => (
                <>
                    {row.totalPremium ? `₹${row.totalPremium.toFixed(2)}` : 
                     row.totalAmount ? `₹${row.totalAmount.toFixed(2)}` : "-"}
                </>
            )
        },

        // {
        //     id: "action",
        //     name: "Action",
        //     center: true,
        //     cell: row => (
        //         <button
        //             type="button"
        //             className="btn btn-sm"
        //             style={{
        //                 background: "#110942",
        //                 color: "#dacd65",
        //                 borderRadius: "8px",
        //                 border: "none"
        //             }}
        //             onClick={() =>
        //                 navigate(
        //                     `/reservations/insurance/TransactionsDetails?ReferenceNo=${row.referenceNo}&clientCode=${row.clientCode}&key=${row.key}`
        //                 )
        //             }
        //         >
        //             Details
        //         </button>
        //     )
        // }
    ];

    const calculateResponsiveColumns = () => {
        if (!tableWrapperRef.current) return;

        const containerWidth = tableWrapperRef.current.clientWidth;
        const expanderWidth = 45;

        const columnWidths = {
            referenceNo: 130,
            organization: 180,
            bookingDate: 130,
            destination: 150,
            policyNo: 120,
            startDate: 120,
            endDate: 120,
            paymentStatus: 140,
            bookingStatus: 140,
            amount: 110,
        };

        let availableWidth = containerWidth - expanderWidth;
        const visible = [];
        const hidden = [];

        // First column ALWAYS visible
        visible.push(allColumns[0]);
        availableWidth -= columnWidths.referenceNo;

        // Check remaining columns based on actual available width
        allColumns.slice(1).forEach(column => {
            const width = columnWidths[column.id] || 120;
            if (availableWidth >= width) {
                visible.push(column);
                availableWidth -= width;
            } else {
                hidden.push(column);
            }
        });

        setVisibleColumns(visible);
        setHiddenColumns(hidden);
    };

    useEffect(() => {
        calculateResponsiveColumns();

        const resizeObserver = new ResizeObserver(() => {
            calculateResponsiveColumns();
        });

        if (tableWrapperRef.current) {
            resizeObserver.observe(tableWrapperRef.current);
        }

        window.addEventListener("resize", calculateResponsiveColumns);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener("resize", calculateResponsiveColumns);
        };
    }, []);

    const ExpandedComponent = ({ data }) => {
        return (
            <div className="expanded-data">
                {hiddenColumns.map(column => (
                    <div key={column.id} className="expanded-item">
                        <strong>{column.name}:</strong>
                        <span>
                            {column.cell
                                ? column.cell(data)
                                : column.selector
                                    ? column.selector(data)
                                    : "-"}
                        </span>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <>
            <HeaderDashboard />

            <div className="toolbar py-2" id="kt_toolbar">
                <div className="container-fluid d-flex align-items-center">
                    <div className="flex-grow-1">
                        <div className="page-title d-flex align-items-center flex-wrap">
                            <h1 className="text-gray-900 fw-bold fs-3">Reservations</h1>
                            <span className="h-20px border-gray-200 border-start mx-3"></span>
                            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                                <li class="breadcrumb-item text-muted">Insurance</li>
                                <li class="breadcrumb-item">
                                    <span class="bullet bg-gray-200 w-5px h-2px"></span>
                                </li>

                                <li class="breadcrumb-item text-gray-900">All Transactions</li>
                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-items-center flex-wrap">
                        <div class="flex-shrink-0 me-2 d-none-mob">
                            <ul class="nav" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <a href='/Dashboard'>
                                        <img src='/assets/images/back.png' width={30} /> </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <section className="wraper">
                <div className="box_shadow mt-14">
                    {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                        <div className="row">
                            <div className="col-md-3 mb-1">
                                <label>Organization </label>
                                <select
                                    className="form-select form-select-solid"
                                    name="organization"
                                    onChange={handleChange}
                                >
                                    <option value="">- All -</option>
                                </select>
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Company </label>
                                <select
                                    className="form-select form-select-solid"
                                    name="company"
                                    onChange={handleChange}
                                >
                                    <option value="">- All -</option>
                                </select>
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Legal Entity </label>
                                <select
                                    className="form-select form-select-solid"
                                    name="legalEntity"
                                    onChange={handleChange}
                                >
                                    <option value="">- All -</option>
                                </select>
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Corporate Traveller </label>
                                <select
                                    className="form-select form-select-solid"
                                    name="corporateTraveller"
                                    onChange={handleChange}
                                >
                                    <option value="">- All -</option>
                                </select>
                            </div>

                            <div className="col-md-3 mb-1">
                                <label>From Date</label>
                                <input
                                    type="text"
                                    id="fromDate"
                                    className="form-control"
                                    placeholder="From Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>To Date</label>
                                <input
                                    type="text"
                                    id="toDate"
                                    className="form-control"
                                    placeholder="To Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Reference No</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="bookingRefNo"
                                    value={filters.bookingRefNo}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-7"
                                    onClick={handleSearch}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                        </div>
                    )}

                    {roles?.includes("Corp Travel Manager", "Corp Administrator") && (
                        <div className="row">
                            <div className="col-md-3 mb-1">
                                <label>From Date</label>
                                <input
                                    type="text"
                                    id="fromDate"
                                    className="form-control"
                                    placeholder="From Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>To Date</label>
                                <input
                                    type="text"
                                    id="toDate"
                                    className="form-control"
                                    placeholder="To Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Reference No</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="bookingRefNo"
                                    value={filters.bookingRefNo}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-7"
                                    onClick={handleSearch}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                        </div>
                    )}

                    {roles?.includes("Corporate Traveller") && (
                        <div className="row">
                            <div className="col-md-3 mb-1">
                                <label>From Date</label>
                                <input
                                    type="text"
                                    id="fromDate"
                                    className="form-control"
                                    placeholder="From Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>To Date</label>
                                <input
                                    type="text"
                                    id="toDate"
                                    className="form-control"
                                    placeholder="To Date"
                                    readOnly
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <label>Reference No</label>
                                <input
                                    className="form-control form-control-solid"
                                    type="text"
                                    name="bookingRefNo"
                                    value={filters.bookingRefNo}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-3 mb-1">
                                <button
                                    type="button"
                                    className="btn btn-primary mt-7"
                                    onClick={handleSearch}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Search"}
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                <div className="box_shadow mt-3">
                    <div className="d-flex justify-content-end align-items-center mb-4">
                        <div style={{ width: "320px" }}>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search Ref No, Entity, Policy..."
                                value={filterText}
                                onChange={(e) =>
                                    setFilterText(e.target.value)
                                }
                            />
                        </div>
                    </div>

                    <div ref={tableWrapperRef} className="transaction-table-wrapper">
                        <DataTable
                            columns={visibleColumns}
                            data={filteredItems}
                            progressPending={loading}
                            pagination
                            paginationPerPage={10}
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            customStyles={customStyles}
                            highlightOnHover
                            striped
                            responsive
                            persistTableHead
                            noDataComponent="No Insurance Transactions Found"
                            expandableRows={hiddenColumns.length > 0}
                            expandableRowsComponent={ExpandedComponent}
                            expandOnRowClicked={false}
                            expandableRowsHideExpander={false}
                            expandableIcon={{
                                collapsed: (
                                    <span className="table-plus-icon">
                                        +
                                    </span>
                                ),
                                expanded: (
                                    <span className="table-plus-icon">
                                        −
                                    </span>
                                )
                            }}
                        />
                    </div>
                </div>
            </section>
        </>
    );
};

export default AllTransactions;